import React from 'react';
import { Box, Select, MenuItem, IconButton, FormControl } from '@mui/material';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';

const months = [
  "ΙΑΝ", "ΦΕΒ", "ΜΑΡ", "ΑΠΡ", "ΜΑΪ", "ΙΟΥΝ",
  "ΙΟΥΛ", "ΑΥΓ", "ΣΕΠ", "ΟΚΤ", "ΝΟΕ", "ΔΕΚ"
];

export default function DateNavigator({ filters, setFilters }) {

  const handleChange = (field) => (event) => {
    const newValue = event.target.value;

    // Δημιουργούμε ένα προσωρινό αντικείμενο με τη νέα τιμή
    let updatedFilters = { ...filters, [field]: newValue };

    // Ειδικός έλεγχος αν αλλάζουμε Μήνα ή Έτος στο mode "day"
    if (filters.mode === 'day' && (field === 'month' || field === 'year')) {
      // Βρίσκουμε πόσες μέρες έχει ο ΝΕΟΣ μήνας/έτος
      const maxDaysInNewMonth = new Date(updatedFilters.year, updatedFilters.month, 0).getDate();

      // Αν η τρέχουσα ημέρα είναι μεγαλύτερη από το όριο του νέου μήνα
      if (updatedFilters.day > maxDaysInNewMonth) {
        updatedFilters.day = maxDaysInNewMonth; // Την "καρφώνουμε" στην τελευταία μέρα (π.χ. 28)
      }
    }

    setFilters(updatedFilters);
  };

  const handleStep = (direction) => {
    const { mode, day, month, year } = filters;
    let date = new Date(year, month - 1, day);

    if (mode === 'day') {
      date.setDate(date.getDate() + direction);
    } else if (mode === 'month') {
      date.setMonth(date.getMonth() + direction);
    } else if (mode === 'year') {
      date.setFullYear(date.getFullYear() + direction);
    }

    setFilters({
      mode,
      year: date.getFullYear(),
      month: date.getMonth() + 1,
      day: date.getDate()
    });
  };

  // Δημιουργία ημερών (1-31)
  const daysInMonth = new Date(filters.year, filters.month, 0).getDate();
  const days = Array.from({ length: daysInMonth }, (_, i) => i + 1);
  // Δημιουργία ετών (π.χ. 2020-2026)
  const years = [2024, 2025, 2026];

  return (
    <Box sx={{
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'center',
      gap: 0.5,
      my: 2,
      flexWrap: { xs: 'wrap', sm: 'nowrap' } // Επιτρέπει την αλλαγή γραμμής σε μικρές οθόνες
    }}>

      {/* Αριστερό Βέλος */}
      <IconButton onClick={() => handleStep(-1)} sx={{ color: 'black' }}>
        <ChevronLeft />
      </IconButton>

      {/* Container για τα Φίλτρα */}
      <Box sx={{
        display: 'flex',
        gap: 0.5,
        alignItems: 'center',
        justifyContent: 'center',
        flexWrap: 'wrap', // Εδώ γίνεται η μαγεία για το mobile
        width: { xs: 'calc(100% - 100px)', sm: 'auto' }
      }}>

        {/* MODE SELECT - Καταλαμβάνει 100% πλάτος σε mobile (520px-719px) */}
        <Select
          value={filters.mode}
          onChange={handleChange('mode')}
          sx={{
            bgcolor: '#eee',
            height: '40px',
            fontWeight: 'bold',
            fontSize: '0.85rem',
            '& .MuiOutlinedInput-notchedOutline': { border: 'none' },
            width: { xs: '100%', sm: 'auto' }, // 100% πλάτος στο mobile
            mb: { xs: 1, sm: 0 }, // Margin bottom 10px μόνο όταν είναι full width
            minWidth: { sm: '100px' }
          }}
        >
          <MenuItem value="day">ΗΜΕΡΑ</MenuItem>
          <MenuItem value="month">ΜΗΝΑΣ</MenuItem>
          <MenuItem value="year">ΕΤΟΣ</MenuItem>
        </Select>

        {/* Group για την Ημερομηνία - Μένουν πάντα στην ίδια σειρά */}
        <Box sx={{ display: 'flex', gap: 0.5, justifyContent: 'center' }}>

          {/* Ημέρα */}
          {filters.mode === 'day' && (
            <Select
              value={filters.day}
              onChange={handleChange('day')}
              sx={{
                bgcolor: '#eee',
                height: '40px',
                width: 'auto', // Σταθερό πλάτος βάσει του CSS σου
                fontSize: '0.85rem',
                '& .MuiOutlinedInput-notchedOutline': { border: 'none' }
              }}
            >
              {days.map(d => <MenuItem key={d} value={d}>{d}</MenuItem>)}
            </Select>
          )}

          {/* Μήνας */}
          {(filters.mode === 'day' || filters.mode === 'month') && (
            <Select
              value={filters.month}
              onChange={handleChange('month')}
              sx={{
                bgcolor: '#eee',
                height: '40px',
                width: 'auto',
                fontSize: '0.85rem',
                '& .MuiOutlinedInput-notchedOutline': { border: 'none' }
              }}
            >
              {months.map((m, index) => <MenuItem key={m} value={index + 1}>{m}</MenuItem>)}
            </Select>
          )}

          {/* Έτος */}
          <Select
            value={filters.year}
            onChange={handleChange('year')}
            sx={{
              bgcolor: '#eee',
              height: '40px',
              width: 'auto', // Λίγο παραπάνω για το έτος
              fontSize: '0.85rem',
              '& .MuiOutlinedInput-notchedOutline': { border: 'none' }
            }}
          >
            {years.map(y => <MenuItem key={y} value={y}>{y}</MenuItem>)}
          </Select>
        </Box>
      </Box>

      {/* Δεξί Βέλος */}
      <IconButton onClick={() => handleStep(1)} sx={{ color: 'black' }}>
        <ChevronRight />
      </IconButton>
    </Box>
  );
}
